import type { RouteRecordRaw } from 'vue-router';
export const crmRoutes: RouteRecordRaw[] = [
  {
    path: 'crm',
    name: 'crm',
    component: () => import('../pages/crm/CrmPage.vue'),
    meta: { requiresModule: 'crm' },
  },
];
